import { Component, OnInit } from '@angular/core';
import { PlayerService } from '../../services/player.service';
import { Player } from '../../objects/player';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '../../../../node_modules/@angular/router';

@Component({
  selector: 's18-player-lookup',
  templateUrl: './player-lookup.component.html',
  styleUrls: ['./player-lookup.component.scss']
})
export class PlayerLookupComponent implements OnInit {
  state:string = 'AZ';
  firstName: string ='';
  lastName: string = '';
  showSearchResults: boolean = false;
  showPlayerInfo: boolean = false;
  busy: boolean = false;

  playerList: Player[] = [];
  playerInfo: Player;

  constructor(
    private playerService: PlayerService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let player_id = params['player_id'];
      if ( player_id != null){
        this.playerService.getPlayerInfo(player_id)
          .subscribe( resp => {
            this.playerInfo = JSON.parse(resp.d)[0];
            this.showPlayerInfo = true;
            this.showSearchResults = false;
          });
      }
    });
  }

  performSearch(){
    this.playerInfo = null;
    this.showPlayerInfo = false;
    this.busy = true;
    this.playerService.playerLookup(this.state, this.firstName, this.lastName)
      .subscribe( resp => {
        this.playerList = JSON.parse(resp.d);
        this.busy = false;
        if ( this.playerList.length > 0){
          this.showSearchResults = true;
        }
      }, () => {
        this.busy = false;
        this.snackbar.open("Unable to get players", null, { panelClass: 'warning-toast', duration: 3000, verticalPosition: 'top', horizontalPosition: 'right' });
      });
  }

  displayPlayerInfo(player: Player){
    this.showPlayerInfo = true;
    this.showSearchResults = false;
    this.playerInfo = player;
  }


}
